import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Hotels from "./pages/Hotels";
import Booking from "./pages/Booking";
import Footer from "./components//Footer"; // ✅ moved to components for consistency
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import CovidInfo from "./pages/CovidInfo";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import DeliveryPolicy from "./pages/DeliveryPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import FAQ from "./pages/FAQ";
import Disclaimer from "./pages/Disclaimer";
import Survey from "./pages/Survey";
import CarHire from "./pages/CarHire";
import TravelInsurance from "./pages/TravelInsurance";
import KenyaTour from "./pages/tours/KenyaTour";
import SriLankaTour from "./pages/tours/SriLankaTour";
import CairoTour from "./pages/tours/CairoTour";
import MessagesTest from "./pages/MessagesTest";

import "./App.css"; // ✅ new CSS for responsiveness

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        {/* Navbar + TopRightForms */}
        <Navbar />
       

        {/* Main Content */}
        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/covid-info" element={<CovidInfo />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/delivery-policy" element={<DeliveryPolicy />} />
            <Route path="/cancellation-refund-policy" element={<RefundPolicy />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/car-hire" element={<CarHire />} />
            <Route path="/travel-insurance" element={<TravelInsurance />} />
            <Route path="/tours/kenya" element={<KenyaTour />} />
            <Route path="/tours/sri-lanka" element={<SriLankaTour />} />
            <Route path="/tours/egypt" element={<CairoTour />} />
            <Route path="/test-messages" element={<MessagesTest />} />

            {/* 404 */}
            <Route path="*" element={<div>Page Not Found</div>} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;
